
import { Button } from "@/components/ui/button";

interface ActionButtonsProps {
  onRetry: () => void;
  onCancel: () => void;
  retryText?: string;
  cancelText?: string;
}

const ActionButtons = ({ 
  onRetry, 
  onCancel, 
  retryText = "Try Again", 
  cancelText = "Go to Products" 
}: ActionButtonsProps) => {
  return (
    <div className="flex flex-col sm:flex-row justify-center gap-3">
      <Button onClick={onRetry} variant="default">
        {retryText}
      </Button>
      <Button onClick={onCancel} variant="outline">
        {cancelText}
      </Button>
    </div>
  );
};

export default ActionButtons;
